import { render, staticRenderFns } from "./DepreciationDetail.vue?vue&type=template&id=6b6b9123&scoped=true"
import script from "./DepreciationDetail.vue?vue&type=script&lang=js"
export * from "./DepreciationDetail.vue?vue&type=script&lang=js"
import style0 from "./DepreciationDetail.vue?vue&type=style&index=0&id=6b6b9123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b9123",
  null
  
)

export default component.exports